// Single source of truth for the backend origin. Real builds always bake
// VITE_API_BASE_URL in via the Docker build arg (see frontend/Dockerfile and
// docker-compose.yml); the localhost fallback only applies when running
// `npm run dev` directly, where the backend listens on port 8000.
export const API_BASE_URL: string =
  // @ts-ignore - Vite env types
  import.meta.env?.VITE_API_BASE_URL || 'http://localhost:8000'

// The iCloud link to the Action Button shortcut, authored once in the
// Shortcuts app and shared from there - Apple offers no way to build or host
// one from code. Empty until that link exists, which the card reads as "show
// the manual steps but no install button" rather than rendering a dead link.
export const IOS_SHORTCUT_URL: string =
  // @ts-ignore - Vite env types
  import.meta.env?.VITE_IOS_SHORTCUT_URL || ''

// The two location shortcuts ("Catch: I arrived" / "Catch: I left"), shared the
// same way (GET-18103). An Arrive/Leave automation runs one of them with the
// place name as input, so the owner never types a URL or a header. Empty until
// the links exist, which the card reads as "show the manual action instead".
export const IOS_ARRIVE_SHORTCUT_URL: string =
  // @ts-ignore - Vite env types
  import.meta.env?.VITE_IOS_ARRIVE_SHORTCUT_URL || ''
export const IOS_LEAVE_SHORTCUT_URL: string =
  // @ts-ignore - Vite env types
  import.meta.env?.VITE_IOS_LEAVE_SHORTCUT_URL || ''
// The signal shortcut ("Catch: signal"), shared the same way (GET-18103). Any
// automation runs it with the signal's name as input, so the owner never types
// a URL or a header. Empty until the link exists, which the card reads as
// "show the request instead".
export const IOS_SIGNAL_SHORTCUT_URL: string =
  // @ts-ignore - Vite env types
  import.meta.env?.VITE_IOS_SIGNAL_SHORTCUT_URL || ''

// The four fixed places ("Catch: I'm home", "Catch: I left the office"...)
// as shortcuts that carry their own Arrive/Leave trigger (GET-18103). iOS 27
// made an automation a shortcut and lets one be shared with its trigger,
// minus the address and the key, so an install is one link plus "pick the
// address". A JSON object in one variable keyed "<transition>:<place>";
// anything that isn't a JSON object of strings reads as empty.
export const IOS_PLACE_AUTOMATION_URLS: Readonly<Record<string, string>> = parsePlaceShortcutUrls(
  // @ts-ignore - Vite env types
  import.meta.env?.VITE_IOS_PLACE_AUTOMATION_URLS || '',
)

export function parsePlaceShortcutUrls(raw: string): Readonly<Record<string, string>> {
  if (!raw) return {}
  try {
    const parsed: unknown = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {}
    return Object.fromEntries(
      Object.entries(parsed as Record<string, unknown>).filter(
        (entry): entry is [string, string] => typeof entry[1] === 'string' && entry[1].length > 0,
      ),
    )
  } catch {
    return {}
  }
}
